import React from 'react';

import { Heading, LoadingIcon, Stack } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export const GeneratingOutput: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Stack
      className="h-96 overflow-hidden rounded-md"
      align="center"
      justify="start"
    >
      <Heading
        size="3xl"
        weight="bold"
        level={3}
        className="relative z-20 text-center"
      >
        {t('appointmentTools.outputs.generatingOutput')}
      </Heading>

      <LoadingIcon size="3xl" className="text-text-accent-secondary" />
    </Stack>
  );
};
